const map = {
	"./bg.json": 4378,
	"./cs.json": 3571,
	"./da.json": 9914,
	"./de.json": 5894,
	"./el.json": 4524,
	"./en.json": 4174,
	"./es.json": 6725,
	"./et.json": 6004,
	"./fi.json": 6808,
	"./fr.json": 4605,
	"./hr.json": 6759,
	"./hu.json": 6938,
	"./is.json": 433,
	"./it.json": 3672,
	"./lt.json": 5449,
	"./lv.json": 1103,
	"./nb.json": 9093,
	"./nl.json": 4943,
	"./pl.json": 1029,
	"./ro.json": 2354,
	"./ru.json": 4600,
	"./sk.json": 347,
	"./sl.json": 7110,
	"./sr.json": 8912,
	"./sv.json": 8252,
	"./th.json": 7549
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7653;